export default "__VITE_ASSET__b7rb2646__"